import {WindowSizesEnum} from '../enums/window-sizes.enum';
import {WindowSizeConfigInterface} from '@core/interfaces/window-size-config.interface';

export function prepareWindowSizeConfig(windowSize: number): WindowSizeConfigInterface {
  return {
    isMobile: windowSize >= WindowSizesEnum.MobileBreakpoint,
    isTablet: windowSize >= WindowSizesEnum.TabletBreakpoint,
    isSmallDesktop: windowSize >= WindowSizesEnum.SmallDesktopBreakpoint,
    isNoteBookDesktop: windowSize >= WindowSizesEnum.isNoteBookDesktop,
    isLargeDesktop: windowSize >= WindowSizesEnum.LargeDesktopBreakpoint,
  };
}

/**
 * Meaning of the WindowSizesEnum
 * isMobile: >= 576px
 * isTablet: >= 768px
 * isSmallDesktop: >= 992px,
 * isNoteBookDesktop: >= 1200px,
 * isLargeDesktop: >= 1440px
 */
